module.exports = __webpack_public_path__ + "static/woman-fr-d05b4fa0e8b1f3fd7b273f8ae622b3a5.jpg";